import React from "react";
import { Zoom } from "react-reveal";
import { useNavigate } from "react-router-dom";
const MaintenanceSearch = ({ x, room_uuid, url }) => {
  const navigate = useNavigate();
  const handleNavigate = () => {
    const target = x.uuid || x.company_uuid;
    if (!target) return;
    navigate(`/${room_uuid}/${url}/${target}`);
  };
  return (
    <li
      id={x.id || x.name}
      onClick={handleNavigate}
      className="maintenance-search"
    >
      <Zoom>
        <a className="bg-white">
          <div className="img-pnl"></div>
          <img src={x.image} alt={x.name || x.service_name || "Maintenance"} />
        </a>
        <p>{x.service_name || x.name}</p>
      </Zoom>
    </li>
  );
};
export default MaintenanceSearch;
